import React from 'react'

import uuid from 'uuidv4'
import moment from 'moment'

export function arrayMove(array, oldIndex, newIndex) {
  if (newIndex >= array.length || newIndex < 0) {
    return array
  }
  array.splice(newIndex, 0, array.splice(oldIndex, 1)[0])
  return array
}

export function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export function filterCaseInsensitive(filter, row) {
  const id = filter.pivotId || filter.id

  if (row[id] !== undefined && row[id] !== null) {
    const rowIdString = row[id].toString()
    const filterString = filter.value.toString()

    return String(rowIdString.toLowerCase()).includes(filterString.toLowerCase())
  }
}

export function filterCaseInsensitiveStartsWith(filter, row) {
  const id = filter.pivotId || filter.id

  if (row[id] !== undefined && row[id] !== null) {
    const rowIdString = row[id].toString()
    const filterString = filter.value.toString()

    return String(rowIdString.toLowerCase()).startsWith(filterString.toLowerCase())
  }
}

export function FormatPhoneNumber(num) {
  var str = num.toString()

  var matched = str.match(/\d+\.?\d*/g)

  // 10 digit
  if (matched.length === 3) {
    return '(' + matched[0] + ') ' + matched[1] + '-' + matched[2]
    // 7 digit
  } else if (matched.length === 2) {
    return matched[0] + '-' + matched[1]
  } else if (matched.length === 1) {
    // no formatting attempted only found integers (i.e. 1234567890)
    // 10 digit
    if (matched[0].length === 10) {
      return (
        '(' + matched[0].substr(0, 3) + ') ' + matched[0].substr(3, 3) + '-' + matched[0].substr(6)
      )
    }
    // 7 digit
    if (matched[0].length === 7) {
      return matched[0].substr(0, 3) + '-' + matched[0].substr(3)
    }
  }

  // Format failed, return number back
  return num
}

export function validateDate(date) {
  if (date === null) {
    return null
  }
  if (date === null) {
    return null
  }
  if (moment.isMoment(date)) {
    return date.format('YYYY-MM-DD hh:mm:ss')
  }
  return date
}

export function convertToOption(data) {
  if (data) {
    return data.map(row => {
      return {
        value: row.id,
        text: row.name
      }
    })
  }
}

export function convertToOptionId(data) {
  if (data) {
    return data.map(row => {
      return {
        id: row.id,
        label: row.name
      }
    })
  }
}

export function convertToAsyncTypeahead(data) {
  if (data) {
    return data.map(row => {
      return {
        value: row.id,
        text: row.name
      }
    })
  }
}

export function convertToReactSelectOption(data) {
  if (data) {
    return data.map(row => {
      return {
        value: row.id,
        label: row.name
      }
    })
  }
}

export function convertToTemplateOption(data) {
  if (data) {
    return data.map(row => {
      return {
        value: row.id,
        text: `${row.id} - ${row.description}`
      }
    })
  }
}

export function convertToProposalOption(data) {
  if (data) {
    return data.map(row => {
      return {
        value: row.id,
        text: `${row.id} - ${row.description}`
      }
    })
  }
}

export function convertNamesToOption(data) {
  if (data) {
    return data.map(row => {
      return {
        value: row.id,
        text: `${row.first_name !== '?' ? row.first_name : ''} ${
          row.last_name !== '?' ? row.last_name : ''
        }`
      }
    })
  }
}

export function convertContactNamesToOption(data) {
  if (data) {
    return data.map(row => {
      return {
        key: row.id,
        value: row.id,
        text: `${row.first_name !== '?' ? row.first_name : ''} ${
          row.last_name !== '?' ? row.last_name : ''
        }`
      }
    })
  }
}

export function listEmails(emailArray) {
  return (
    <div>
      <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
        {emailArray &&
          emailArray.map(email => {
            return email.address ? <li>{email.address}</li> : ''
          })}
      </ul>
    </div>
  )
}

export function listEmailBarebones(emailArray) {
  let emailList = ''
  emailArray.forEach(email => (emailList += email.address + ', '))
  return emailList.substr(0, emailList.length - 2)
}

export function listPhoneNumbers(phoneArray) {
  return (
    <div>
      <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
        {phoneArray &&
          phoneArray.map(phone => {
            return phone.number ? (
              <li>
                {FormatPhoneNumber(phone.number)} ({phone.type})
              </li>
            ) : (
              ''
            )
          })}
      </ul>
    </div>
  )
}

export function listPhoneNumbersBarebones(phoneArray) {
  let phoneList = ''
  phoneArray.forEach(
    phone => (phoneList += phone.number ? FormatPhoneNumber(phone.number) + ', ' : '')
  )
  return phoneList.substr(0, phoneList.length - 2)
}

export function removeCurrencyMarkup(currency) {
  const str = currency ? currency.toString() : ''
  return Number(str.replace(/[^0-9\.-]+/g, '')).toFixed(2)
}

export function sanitizeItem(item) {
  item.cost = +removeCurrencyMarkup(item.cost)
  item.sub_total = +removeCurrencyMarkup(item.sub_total)
  item.overhead_total = +removeCurrencyMarkup(item.overhead_total)
  item.markup_total = +removeCurrencyMarkup(item.markup_total)
  item.tax_total = +removeCurrencyMarkup(item.tax_total)
  return item
}

export function handleItemCalcs(item) {
  let calculatedItem = { ...item }
  calculatedItem.sub_total = item.cost * item.quantity
  calculatedItem.overhead_total = item.remove_default_overhead
    ? calculatedItem.sub_total * item.overhead
    : 0
  calculatedItem.acumulated_overhead_total = calculatedItem.sub_total * (item.overhead + 1)
  calculatedItem.markup_total = item.remove_default_markup
    ? calculatedItem.acumulated_overhead_total * item.markup
    : 0
  calculatedItem.acumulated_markup_total =
    calculatedItem.acumulated_overhead_total * (item.markup + 1)
  calculatedItem.tax_total =
    item.tax && item.remove_default_tax ? calculatedItem.sub_total * item.tax : 0
  calculatedItem.grand_total =
    calculatedItem.sub_total +
    calculatedItem.overhead_total +
    calculatedItem.markup_total +
    calculatedItem.tax_total

  delete calculatedItem.acumulated_overhead_total
  delete calculatedItem.acumulated_markup_total

  return calculatedItem
}

export function getSelectedOrganization(organizations, value) {
  const selectedOrganization = organizations.find(organization => organization.name === value)
  return selectedOrganization ? +selectedOrganization.id : +value
}

export function changeProposalItemValue(value, itemId, items) {
  const modifiedItems = items.map((item, index) => {
    if (item.id === itemId || item.tmpId === itemId) {
      item.description = value
    } else {
      if (item.items) {
        changeProposalItemValue(value, itemId, item.items)
      }
    }

    return item
  })

  return modifiedItems
}

function indentItemRight(items, item) {
  items.forEach((currentItem, index) => {
    if (
      (item.id && currentItem.id === item.id) ||
      (item.tmpId && currentItem.tmpId === item.tmpId)
    ) {
      // verify the item above currentItem
      if (items[index - 1].items) {
        items[index - 1].items.push(currentItem)
      } else {
        items[index - 1].items = [currentItem]
      }
      items.splice(index, 1)
    } else {
      if (currentItem.items) {
        indentItemRight(currentItem.items, item)
      }
    }
  })

  return items
}

function findParentAndInsertNewChild(items, item, itemToInsert) {
  items.forEach((currentItem, index, array) => {
    if (
      (item.id && currentItem.id === item.id) ||
      (item.tmpId && currentItem.tmpId === item.tmpId)
    ) {
      itemToInsert.parent_item_id = currentItem.parent_item_id ? item.parent_item_id : undefined
      items.splice(index + 1, 0, itemToInsert)
    } else {
      if (currentItem.items) {
        findParentAndInsertNewChild(currentItem.items, item, itemToInsert)
      }
    }
  })
}

function indentItemLeft(items, item, parent, originalArray) {
  items.forEach((currentItem, index, array) => {
    if (
      (item.id && currentItem.id === item.id) ||
      (item.tmpId && currentItem.tmpId === item.tmpId)
    ) {
      if (parent) {
        currentItem.parent_item_id = parent.parent_item_id
        findParentAndInsertNewChild(originalArray, parent, currentItem)
      } else {
        currentItem.parent_item_id = undefined
        items.splice(index, 0, currentItem)
      }
      items.splice(index, 1)
    } else {
      if (currentItem.items) {
        indentItemLeft(currentItem.items, item, currentItem, items)
      }
    }
  })

  return items
}

function moveItemUp(items, item) {
  items.forEach((currentItem, index) => {
    if (
      (item.id && currentItem.id === item.id) ||
      (item.tmpId && currentItem.tmpId === item.tmpId)
    ) {
      arrayMove(items, index, index - 1)
    } else {
      if (currentItem.items) {
        moveItemUp(currentItem.items, item)
      }
    }
  })

  return items
}

function moveItemDown(items, item) {
  let moved = false
  items.forEach((currentItem, index) => {
    if (
      (!moved && item.id && currentItem.id === item.id) ||
      (!moved && item.tmpId && currentItem.tmpId === item.tmpId)
    ) {
      moved = true
      arrayMove(items, index, index + 1)
    } else {
      if (currentItem.items) {
        moveItemDown(currentItem.items, item)
      }
    }
  })

  return items
}

function deleteItem(items, item) {
  items.forEach((currentItem, index, array) => {
    if (currentItem.id === item.id) {
      items.splice(index, 1)
    }
  })

  return items
}

export function changeSectionItemsStructure(action, items, item) {
  let newItemmStructure = []
  if (action === 'moveRight') {
    newItemmStructure = indentItemRight(items, item)
  } else if (action === 'moveLeft') {
    newItemmStructure = indentItemLeft(items, item, null, items)
  } else if (action === 'moveUp') {
    newItemmStructure = moveItemUp(items, item)
  } else if (action === 'moveDown') {
    newItemmStructure = moveItemDown(items, item)
  } else if (action === 'delete') {
    newItemmStructure = deleteItem(items, item)
  }
  return newItemmStructure
}

export const generateUniqueId = () => {
  return (
    Date.now().toString(36) +
    Math.random()
      .toString(36)
      .substr(2, 5)
  ).toUpperCase()
}

export function getDaysArrayByMonth() {
  var daysInMonth = moment().daysInMonth()
  var arrDays = []

  while (daysInMonth) {
    var current = moment()
      .date(daysInMonth)
      .format('MM/DD')
    arrDays.push(current)
    daysInMonth--
  }

  return arrDays
}

export function addressFilter(address) {
  var addressStr = ''

  if (!address || address === null) {
    return ''
  }

  if (address.address1 !== null && address.address1 !== '') {
    addressStr += address.address1 + ' '
  }

  if (address.address2 !== null && address.address2 !== '') {
    addressStr += address.address2 + ' '
  }

  if (address.city !== null && address.city !== '') {
    addressStr += address.city + ' '
  }

  if (address.state !== null && address.state !== '') {
    addressStr += address.state + ' '
  }

  if (address.zip !== null && address.zip !== '') {
    addressStr += address.zip + ' '
  }

  return addressStr.trim()
}

export function sanitizeProposalClonedItems(items) {
  items.forEach(item => {
    delete item.id
    delete item.proposal_id
    delete item.parent_item_id
    delete item.proposal_section_id
    delete item.created_by_id
    delete item.created_date
    delete item.item_id
    delete item.name
    delete item.quantity
    delete item.updated_by_id
    delete item.updated_date

    item.tmpId = uuid()
  })
}

function sanitizeProposalSectionItem(item, parentSectionId, parentItemId) {
  delete item.id
  delete item.proposal_id
  delete item.parent_item_id
  delete item.proposal_section_id
  delete item.proposal_section_template_id
  delete item.created_by_id
  delete item.created_date
  delete item.item_id
  delete item.quantity
  delete item.updated_by_id
  delete item.updated_date

  item.tmpId = uuid()
  item.parentItemId = parentItemId
  item.proposal_section_id = parentSectionId

  if (item.items) {
    for (const itemChildren of item.items) {
      sanitizeProposalSectionItem(itemChildren, parentSectionId, item.tmpId)
    }
  }
}

export function sanitizeProposalTemplateSection(section) {
  const sectionTmpUuid = uuid()

  delete section.created_by_id
  delete section.created_date
  delete section.proposal_template_id
  delete section.updated_by_id
  delete section.updated_date
  delete section.id

  section.tmpId = sectionTmpUuid

  if (section.items) {
    for (let item of section.items) {
      sanitizeProposalSectionItem(item, sectionTmpUuid)
    }
  }
}

export function sanitizeProposalTempltateMilestones(milestones) {
  if (milestones) {
    for (const milestone of milestones) {
      delete milestone.id
    }
  }
}

export const getSorterStringFn = attr => (a, b, order) => {
  if (a[attr] === null || a[attr] === '') {
    return order === 'descend' ? -1 : 1
  } else if (b[attr] === null || b[attr] === '') {
    return 1
  }
  return a[attr].localeCompare(b[attr])
}

export function removeProp(obj, propToDelete) {
  for (var property in obj) {
    if (obj.hasOwnProperty(property)) {
      if (typeof obj[property] === 'object') {
        removeProp(obj[property], propToDelete)
      } else {
        if (property.toString() === propToDelete) {
          delete obj[property]
        }
      }
    }
  }

  return obj
}

export const sanitizeEstimateSectionsForCloning = sections => {
  for (let section of sections) {
    removeProp(section, 'id')
  }
  return sections
}

export function detectMobile() {
  const { userAgent } = navigator
  if (
    userAgent.match(/Android/i) ||
    userAgent.match(/webOS/i) ||
    userAgent.match(/iPhone/i) ||
    userAgent.match(/iPad/i) ||
    userAgent.match(/iPod/i) ||
    userAgent.match(/BlackBerry/i) ||
    userAgent.match(/Windows Phone/i)
  ) {
    return true
  } else {
    return false
  }
}

export function getModalId(pathname) {
  const regex = /modal\/(\d+)$/
  const match = regex.exec(pathname)
  if (match === null) {
    return 0
  }
  return match[1] || 0
}



// WEBPACK FOOTER //
// ./src/util/index.js